import { Container } from "@mui/material";

import { Add, Dashboard, DoneOutlined, Edit, ImportExport, Person, Settings } from "@mui/icons-material";
import { Box, Stack } from "@mui/material";
import Sidebar, { SidebarItem } from "../../components/util/Sidebar/Sidebar";

const sidebarItems: SidebarItem[] = [
    { text: 'Dashboard', icon: <Dashboard />, path: '/admin', exact: true },
    { text: 'User', icon: <Person />, path: '/admin/users' },
    { text: 'Create Job', icon: <Add />, path: '/admin/create-job' },
    { text: 'Update Job', icon: <Edit />, path: '/admin/update-job' },
    { text: 'Import Data', icon: <ImportExport />, path: '/admin/import-data' },
    "divider",
    { text: 'Accept Applications', icon: <DoneOutlined />, path: '/admin/accept-applications' },
    { text: 'Server Settings', icon: <Settings />, path: '/admin/server-settings' },
];


const AdminPanelWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <Stack direction="row" minHeight={1} justifyContent="center">
            <Sidebar items={sidebarItems} title="CMS Management" />
            <Box sx={{
                width: 1,
                overflowX: 'auto',
                overflowY: 'auto',
                display: 'block'
            }}>
                <Container maxWidth="lg" sx={{ overflowX: 'auto', py: 4 }}>
                    {children}
                </Container>
            </Box>
        </Stack>)
}

export default AdminPanelWrapper;   
